import { OFFER_INVALID_REASON, OFFER_LOCALE_LIST } from '@ag1/atlas';

// Sync with `CHECKOUT_FLOW_TYPES` in Atlas.
export const SUPPORTED_CHECKOUT_FLOW_TYPES = ['bab'] as const;

export const ValidLanguages = [
  ...OFFER_LOCALE_LIST,
  // Not actually supported in Atlas but I don't know if removing it will break
  // anything.
  'jp'
] as const;

export const DefaultLanguage = ValidLanguages[0];

export enum OfferSubscriptionFlavorType {
  Original = 'original',
  Tropical = 'tropical',
  Berry = 'berry'
}

export enum PDPType {
  Bundle = 'bundle',
  Product = 'product'
}

export const OFFER_INVALID_REASON_404 = [OFFER_INVALID_REASON.UnsupportedLocale] as const;
